import React from 'react';
import { trackHeroCTAClick } from '../utils/analytics';

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="hero" id="hero">
      <div className="hero-radial" />
      <div className="hero-content">
        <div className="hero-badge">
          <div className="hero-badge-dot" />
          Edge AI Analytics Platform
        </div>
        <h1>From Video<br />to <strong>Operational Intelligence</strong></h1>
        <p className="hero-sub">
          Turn your existing cameras into operational metrics &mdash;<br />processed on-site &bull; no cloud video &bull; optimized for remote facilities
        </p>
        <div className="hero-actions">
          <button className="btn-primary" onClick={() => { trackHeroCTAClick('request_a_demo'); scrollTo('contact'); }}>Request a Demo</button>
          <button className="btn-ghost" onClick={() => { trackHeroCTAClick('see_how_it_works'); scrollTo('how-it-works'); }}>See How It Works</button>
        </div>
      </div>
      <div className="hero-scroll-hint">
        <span>Scroll</span>
        <div className="scroll-line" />
      </div>
    </section>
  );
}
